
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Resortinnagpurdistricforcorporateouting() {



  const cardData =
  {
    keyword: ' Resort in Nagpur District for Corporate Outings',
    heading:  'Woodland Escape: Resort in Nagpur District for Corporate Outings ',
    headingDescription: 'Woodland Escape Resort is an excellent resort in Nagpur District for corporate outings, offering a blend of nature, space and modern amenities tailored for team activities and professional retreats. Situated in a tranquil forest-fringed setting, it provides wide open lawns and shaded zones ideal for group workshops, team-building games, informal brainstorming sessions and outdoor bonding experiences—all away from the city bustle. The resort combines comfortable cottages, group dining arrangements, and seamless event coordination to ensure smooth logistics for your corporate group. Whether you’re planning a day-long offsite, multi-day retreat or a team outing with fun and focus, Woodland Escape Resort delivers a setting where business meets nature, productivity meets relaxation, and teams can refresh, reconnect and recharge.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Resort in Nagpur District for Corporate Outings",
      "description": "Ideal for companies seeking a blend of productivity and relaxation, this resort offers serene surroundings, meeting spaces, team-building activities, and luxury accommodations for corporate retreats."
    },
    {
      "name": "Nagpur Team Outing Resort",
      "description": "Perfect for team-building events, this resort features adventure activities, outdoor games, conference halls, and recreational facilities designed to strengthen teamwork and boost morale."
    },
    {
      "name": "Nagpur Corporate Stay Resort",
      "description": "Combining work and leisure, this resort provides fully-equipped business rooms, high-speed internet, meeting facilities, and comfortable accommodations for corporate guests."
    },
    {
      "name": "Nagpur Business Retreat Resort",
      "description": "A serene escape from the city, this resort offers dedicated conference halls, brainstorming areas, outdoor team activities, and luxurious stay options, making it perfect for productive retreats."
    },
    {
      "name": "Nagpur Conference Resort",
      "description": "Designed for corporate conferences, this resort offers state-of-the-art meeting rooms, audio-visual equipment, and professional support staff, alongside scenic surroundings for a refreshing experience."
    },
    {
      "name": "Nagpur Eco Corporate Resort",
      "description": "An eco-friendly resort combining sustainability with corporate functionality. Features include green meeting spaces, outdoor team-building activities, and luxury accommodations in a natural setting."
    },
    {
      "name": "Nagpur Riverside Corporate Resort",
      "description": "Nestled near a river, this resort offers scenic views, outdoor team activities, meeting halls, and luxurious stay options, ideal for a rejuvenating corporate outing."
    },
    {
      "name": "Nagpur Hill Corporate Resort",
      "description": "Perched on hills, this resort provides panoramic views, adventure-based team-building activities, serene workspaces, and comfortable lodging for corporate guests."
    },
    {
      "name": "Nagpur Adventure Corporate Resort",
      "description": "Perfect for adventurous team retreats, this resort offers obstacle courses, zip-lining, trekking, and other outdoor activities to foster teamwork, alongside well-equipped conference facilities."
    },
    {
      "name": "Nagpur Luxury Corporate Resort",
      "description": "A premium resort offering top-notch corporate amenities, luxurious suites, fine dining, spa facilities, and scenic surroundings, combining business and leisure seamlessly."
    },
    {
      "name": "Nagpur Weekend Corporate Resort",
      "description": "Tailored for short corporate getaways, this resort provides weekend packages including team-building exercises, relaxation activities, and luxury accommodations for company groups."
    },
    {
      "name": "Nagpur Booking Corporate Resort",
      "description": "Easy online booking for corporate groups, customizable packages for retreats, meetings, or team outings, and access to all resort amenities and scenic locations."
    },
    {
      "name": "Nagpur One Day Corporate Resort",
      "description": "Ideal for one-day corporate retreats, this resort offers meeting halls, team activities, outdoor recreational options, and quick yet refreshing experiences in nature."
    },
    {
      "name": "Nagpur Group Retreat Resort",
      "description": "Perfect for corporate groups, this resort provides group accommodation, collaborative outdoor activities, conferencing facilities, and relaxing natural surroundings."
    },
    {
      "name": "Nagpur Outdoor Corporate Resort",
      "description": "Designed for outdoor corporate events, this resort offers adventure sports, obstacle courses, nature trails, and team-building activities alongside modern workspaces and lodging."
    }
  ],
  "tableData": [
    ["- Resort in Nagpur District for Corporate Outings", "- Nagpur Team Outing Resort"],
    ["- Nagpur Corporate Stay Resort", "- Nagpur Business Retreat Resort"],
    ["- Nagpur Conference Resort", "- Nagpur Eco Corporate Resort"],
    ["- Nagpur Riverside Corporate Resort", "- Nagpur Hill Corporate Resort"],
    ["- Nagpur Adventure Corporate Resort", "- Nagpur Luxury Corporate Resort"],
    ["- Nagpur Weekend Corporate Resort", "- Nagpur Booking Corporate Resort"],
    ["- Nagpur One Day Corporate Resort", "- Nagpur Group Retreat Resort"],
    ["- Nagpur Outdoor Corporate Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Corporate Outing Resort in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers a serene and professional environment ideal for corporate outings, team-building activities, and leadership retreats. Surrounded by lush greenery and tranquil forest landscapes, it combines productivity with relaxation."
  },
  {
    "WhyChooseheading": "Spacious Meeting and Activity Spaces",
    "WhyChoosedescription": "The resort provides well-equipped conference rooms, open-air meeting zones, and outdoor activity areas. Teams can conduct brainstorming sessions, workshops, or training programs while enjoying a refreshing natural ambiance."
  },
  {
    "WhyChooseheading": "Team-Building and Adventure Activities",
    "WhyChoosedescription": "Guests can engage in team-building exercises, obstacle courses, nature treks, cycling, and pond-side activities. These experiences promote collaboration, bonding, and morale-boosting while making the outing memorable and fun."
  },
  {
    "WhyChooseheading": "Comfortable Accommodation for Teams",
    "WhyChoosedescription": "Woodland Escape Resort features comfortable rooms and cottages suitable for corporate groups. Modern amenities, forest views, and cozy interiors ensure a restful stay after a day of productive sessions and outdoor activities."
  },
  {
    "WhyChooseheading": "Healthy and Delicious Meals",
    "WhyChoosedescription": "The resort offers freshly prepared meals, snacks, and beverages, catering to the preferences and dietary needs of corporate groups. Guests can enjoy nutritious and satisfying food during their stay."
  },
  {
    "WhyChooseheading": "Rejuvenating Natural Environment",
    "WhyChoosedescription": "The resort’s lush surroundings, walking trails, and open green spaces provide a rejuvenating escape from the city. Teams can unwind, refresh, and return to work energized and inspired."
  },
  {
    "WhyChooseheading": "Accessible Yet Private Location",
    "WhyChoosedescription": "Located within Nagpur District, Woodland Escape Resort is conveniently reachable while maintaining privacy and tranquility. Corporate groups can enjoy a secluded, nature-filled environment without long travel."
  }
]



































  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a corporate outing in Nagpur district?",
    answer: "Woodland Escape Resort offers an ideal venue for corporate outings in Nagpur district—with its spacious grounds, nature‑rich surroundings and professional amenities, it facilitates team building, strategy meets and relaxed bonding experiences."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city for a corporate group?",
    answer: "The resort is located within a comfortable driving distance from Nagpur city, making it convenient for corporate groups to travel, conduct sessions and return or stay overnight without excessive commute."
  },
  {
    question: "What corporate‑friendly facilities does Woodland Escape Resort provide?",
    answer: "The resort features meeting and event spaces, open‑lawn areas for team games, breakout zones in nature, comfortable accommodation, dining services and optional add‑ons like outdoor activities, making it suitable for all‑day corporate outings."
  },
  {
    question: "Is Woodland Escape Resort suitable for teams of various sizes, from small groups to larger corporate teams?",
    answer: "Yes! The resort is designed with flexibility in mind—whether it’s a small leadership offsite or a larger team gathering, the resort offers safe, comfortable, and adaptable spaces to accommodate various group sizes and goals."
  },
  {
    question: "Does the resort provide catering and agenda‑support services for corporate outings?",
    answer: "Yes. Woodland Escape Resort offers freshly prepared meals, snacks, beverages, and supportive staff to assist with event logistics, dining arrangements and activity scheduling—making your corporate outing seamless and productive."
  },
  {
    question: "How can we book Woodland Escape Resort for a corporate outing in Nagpur district?",
    answer: "You can book by contacting the resort’s reservation team via phone or WhatsApp, or by visiting the official website. It is advisable to book well in advance—especially if you require meeting rooms, team‑activities and specific date slots."
  }
];

const testimonials = [
  {
    name: "XYZ Corp Team, Nagpur",
    text: "Our team outing at Woodland Escape Resort was outstanding! The meeting space and the open lawn team‑games setup complemented our work break perfectly. Highly recommended for corporate outings in Nagpur district."
  },
  {
    name: "ABC Enterprises, Nagpur",
    text: "We chose Woodland Escape Resort for our quarterly team off‑site and it exceeded expectations. The nature‑rich setting, comfortable rooms and helpful staff made our outing both productive and refreshing."
  }
];


































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const corporateResortSchema = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "name": "Resort in Nagpur District for Corporate Outings",
  "image": "https://woodlandescape.com/assets/images/nagpur-corporate-resort.jpg",
  "description": "Host your corporate outings, team retreats, and business conferences at our Nagpur District resort. Enjoy luxury, outdoor activities, and eco-friendly surroundings perfect for team-building and executive stays.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Nagpur",
    "addressRegion": "Maharashtra",
    "addressCountry": "IN"
  },
  "telephone": "+91-XXXXXXXXXX",
  "url": "https://woodlandescape.com/nagpur-corporate-resort",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "reviewCount": "34",
    "bestRating": "5",
    "worstRating": "1"
  },
  "amenityFeature": [
    {"@type": "LocationFeatureSpecification", "name": "Corporate Retreats", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Team Building Activities", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Business Conference Facilities", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Eco-Friendly Resort", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Riverside & Hill Views", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Luxury Stay & Outdoor Adventure", "value": true}
  ]
};



  return (
    <div>

<Helmet>
  <title>Resort in Nagpur District for Corporate Outings | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your corporate outings, team retreats, and business conferences at our Nagpur District resort. Luxury stays, adventure activities, and eco-friendly surroundings await your team." 
  />
  <meta 
    name="keywords" 
    content="Resort in Nagpur District for Corporate Outings, Nagpur Team Outing Resort, Nagpur Corporate Stay Resort, Nagpur Business Retreat Resort, Nagpur Conference Resort, Nagpur Eco Corporate Resort, Nagpur Riverside Corporate Resort, Nagpur Hill Corporate Resort, Nagpur Adventure Corporate Resort, Nagpur Luxury Corporate Resort, Nagpur Weekend Corporate Resort, Nagpur Booking Corporate Resort, Nagpur One Day Corporate Resort, Nagpur Group Retreat Resort, Nagpur Outdoor Corporate Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateResortSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/59.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Resortinnagpurdistricforcorporateouting;